import React from 'react';
import { Button, ButtonProps } from '../Button/Button';
import { useTopBarStore } from '../TopBar/TopBarStore';
import { SmartHelpContentProps } from './SmartHelp';
import { usePreloadSmartHelp } from './SmartHelpQuery';

// A convenience "Learn more" button that opens the Smart Help menu in the top bar with an optional specific query and question.
export function LearnMoreButton({
	help,
	children,
	...props
}: React.PropsWithChildren<{
	help?: SmartHelpContentProps;
} & ButtonProps>) {
	const setSmartHelp = useTopBarStore((state) => state.setSmartHelp);
	const setSmartHelpOpen = useTopBarStore((state) => state.setSmartHelpOpen);
	const preloadSmartHelp = usePreloadSmartHelp(help);

	return (
		<Button
			variant="outlined"
			onMouseOver={() => help && preloadSmartHelp()}
			onClick={() => {
				if (help) {
					setSmartHelp(help);
				}
				setSmartHelpOpen(true);
			}}
			{...props}
		>
			{children ?? 'Learn more'}
		</Button>
	);
}
